import "bootstrap/dist/js/bootstrap.bundle.min.js";

window.onload = function() {
  document.body.style.zoom = "100%"; // Reset zoom to 100% on load
}

//json
window.Translator = {
  en: {
    word: require("../json/lang/en/word.json"),
  },
  ar: {
    word: require("../json/lang/ar/word.json"),
  },
};

//JS
//window.bootstrap = require('bootstrap/dist/js/bootstrap');
window.$ = window.jQuery = require('jquery');

// import the main components
const { createApp, ref } = require("vue");
import VueFooter from "./VueComponents/Footer.vue";
import VueGlobal from "./VueGlobal.js";
import router from "./Router.js";

// initialize the vueApp
const vueApp = createApp({
  // Optionally, you can define other state or logic here
  data() {
    return {};
  },
  methods: {},
  watch: {
    locale: function (newValue, oldValue) {
      if (oldValue !== newValue || GetLocalization() !== newValue) {
        this.locale = newValue;
        this.SetLocalization(newValue);
      }
    },
  },
});

vueApp.component("vue-footer", VueFooter);

// Register global properties and other settings
VueGlobal(vueApp);

// Use the router
vueApp.use(router);

vueApp.mount("#vueApp");
window.axios = require('axios');
window.moment = require('moment');
window.toastr = require('toastr');
require('block-ui');

// import the other js files
import "./Common.js";
import "./API_Collection.js";
